import { Icon } from 'assets/icons';
import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import styles from './input.module.css';

export const RangeInput = ({
  label = '',
  input_id = '',
  is_rounded,
  className = '',
  wrapperClassName = '',
  disabled,
  minValue = 0,
  maxValue = 0,
  onInput = () => {},
  required = false,
  autoFocus = false,
  error = ''
}) => {
  const [min, setMin] = useState();
  const [max, setMax] = useState();

  useEffect(() => {
    onInput({ min, max });
  }, [max, min]);

  return (
    <div className={cx(styles.formGroup, is_rounded && styles.rounded, wrapperClassName)}>
      {label && (
        <label htmlFor={input_id}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
      )}
      <div style={{ display: 'flex', gap: '20px' }}>
        <input
          type={'number'}
          value={minValue}
          onChange={() => {}}
          onInput={(e) => setMin(e.target.value)}
          className={cx(className, { [styles.errorBorder]: error })}
          id={`${input_id}-min`}
          disabled={disabled}
          autoFocus={autoFocus}
        />
        <input
          type={'number'}
          value={maxValue}
          onChange={() => {}}
          onInput={(e) => setMax(e.target.value)}
          className={cx(className, { [styles.errorBorder]: error })}
          id={`${input_id}-max`}
          disabled={disabled}
          autoFocus={autoFocus}
        />
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export const SimpleInput = ({
  type = 'text',
  label = '',
  name = '',
  input_id = '',
  is_rounded,
  className = '',
  wrapperClassName = '',
  disabled,
  placeholder = '',
  value = '',
  min = '',
  max = '',
  onBlur = () => {},
  onInput = () => {},
  onKeyDown = () => {},
  style = {},
  required = false,
  autoFocus = false,
  error = ''
}) => {
  return (
    <div className={cx(styles.formGroup, is_rounded && styles.rounded, wrapperClassName)}>
      {label && (
        <label htmlFor={input_id}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        name={name}
        onChange={() => {}}
        onKeyDown={onKeyDown}
        onInput={(e) => (name ? onInput(e.target) : onInput(e.target.value))}
        onBlur={onBlur}
        className={cx(className, { [styles.errorBorder]: error })}
        style={style}
        id={input_id}
        disabled={disabled}
        min={min}
        max={max}
        autoFocus={autoFocus}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export const IconInput = ({
  type = 'text',
  icon_name = 'add',
  is_rounded,
  label = '',
  input_id = '',
  className = '',
  iconClassName = '',
  wrapperClassName = '',
  disabled,
  placeholder = '',
  value = '',
  onBlur = () => {},
  onInput = () => {},
  onIconClick = () => {},
  style = {},
  icon_position = 'left',
  autoFocus,
  error = ''
}) => {
  const noPadding = icon_position === 'left';
  return (
    <div>
      <div
        className={cx(styles.iconFormGroup, is_rounded && styles.rounded, wrapperClassName, {
          [styles.errorBorder]: error
        })}
      >
        {label && <label htmlFor={input_id}>{label}</label>}

        {icon_position === 'left' && (
          <span onClick={onIconClick} className={cx(styles.inputIcon, iconClassName)}>
            <Icon name={icon_name} />
          </span>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          onInput={(e) => onInput(e.target.value)}
          onChange={() => {}}
          className={cx({ [styles.inputIconLeft]: noPadding }, className)}
          style={style}
          id={input_id}
          disabled={disabled}
          autoFocus={autoFocus}
        />
        {icon_position === 'right' && (
          <span onClick={onIconClick} className={styles.inputIcon}>
            <Icon name={icon_name} />
          </span>
        )}
      </div>
      {error && <span className={cx(styles.error, 'mb-4 d-inline-block')}>{error}</span>}
    </div>
  );
};
